import { ButtonBase, Typography } from '@material-ui/core'
import React from 'react'
import { useLocation } from 'react-router-dom'

import { LocalizedLink } from '../../routes/localizedRoutes'
import { RatePlanBrief } from '../../types/rateplan'
import useStyles from './styles/RateplansTable.styles'

interface RatePlanRowMobileProps {
  data: RatePlanBrief
  roomTypeid: string
  hasAccessToViewRatePlanTabs: boolean | undefined
}

const RatePlanRowMobile: React.FC<RatePlanRowMobileProps> = ({
  data,
  roomTypeid,
  hasAccessToViewRatePlanTabs
}) => {
  const { id, name, displayRatePlanCode, ratePlanCode, roomTypeCode } = data

  const classes = useStyles()
  const location = useLocation()

  return (
    <>
      <ButtonBase
        className={classes.tableRowMobile}
        component={LocalizedLink}
        to={
          hasAccessToViewRatePlanTabs
            ? `${location.pathname
                .replace('/list', '')
                .replace('/rate-plans', '')
                .replace('/en', '')
                .replace(
                  '/fa',
                  ''
                )}/room-type/${roomTypeid}/${roomTypeCode}/rate-plans/${id}/${ratePlanCode}/details`
            : ''
        }>
        <div className={classes.nameCell}>
          <Typography variant="h4">{name}</Typography>
        </div>
        <div>
          <Typography variant="body1">{displayRatePlanCode}</Typography>
        </div>
      </ButtonBase>
    </>
  )
}

export default RatePlanRowMobile
